import { render, staticRenderFns } from "./CusstomEditor.vue?vue&type=template&id=0107978b&scoped=true&"
import script from "./CusstomEditor.vue?vue&type=script&lang=js&"
export * from "./CusstomEditor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CusstomEditor.vue?vue&type=style&index=1&id=0107978b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107978b",
  null
  
)

export default component.exports